var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-container',{staticClass:"container-custom"},[_c('v-row',[_c('v-col',{attrs:{"md":"12"}},[_c('h1',{staticClass:"systemTitle"},[_vm._v("Contacts")]),_c('Contact',{attrs:{"paginationStatus":"true"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }